import mobx, { observable, action, computed } from 'mobx';
import api from '../../api';
import moment from 'moment';
// import accountStore from '../accountStore';
// import appStore from '../appStore';

export default class Previous {

	store = null;
	@observable data = null;
	@observable isLoading = 0;
	@observable selected = {
		month: moment().month() + 1,
		year: moment().year()
	};

	constructor(store) {
		this.store = store;
	}

	@action init(params) {
		this.store.isLoading = 0;
		this.getData();
	}

	@action dispose() {

	}

	@action selectYear(v) {
		if (this.selected.year != v) {
			this.selected.year = v;
			if (v == 2008) this.selected.month = 12;
			if (!this.data.date_menu[v][this.selected.month]) {
				const arr =  Object.keys(this.data.date_menu[v]);
				this.selected.month = arr[arr.length - 1];
			}
		}
	}

	@computed get draw() {
		return this.data.date_menu[this.selected.year][this.selected.month];
	}

	@action selectMonth(v) {
		if (this.selected.year != v) {
			this.selected.month = v;
		}
	}

	@action getData(more){
		api.toto.getPrevious().then(
			action( data => { 
				if (data.code == "OK") {
					this.data = data.result;
					this.selected.month = data.result.month ? data.result.month : moment().month() + 1;
					this.selected.year = data.result.year ? data.result.year : moment().year();
				}
			}))
      .catch(action(err => {
        this.store.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.store.isLoading = 1 }));
	}
}


// WEBPACK FOOTER //
// ./src/stores/totoStore/previous.js